import JInput from './input'

export default JInput



// WEBPACK FOOTER //
// ./src/components/input/index.js